/* @flow */
import React from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { ListItem } from 'material-ui/List';
import ActionInfo from 'material-ui/svg-icons/action/info';
import Avatar from 'material-ui/Avatar';

import Duration from '../../../components/Duration';
import DateTime from '../../../components/DateTime';
import type { StudentJobSessionHistory_session } from './__generated__/StudentJobSessionHistory_session.graphql';

type Props = {
  session: StudentJobSessionHistory_session,
};

const StudentJobSessionHistory = ({
  session: {
    number,
    timeSlot,
    job: { acceptedJobOffer: { tutor, jobRequest }, sessionCount },
  },
}: Props) => {
  const { grade, subject } = jobRequest;
  const { fullname, profilePictureUri } = tutor;

  const secondaryText =
    sessionCount > 1
      ? `${fullname} - (${number} of ${sessionCount + 1})`
      : fullname;

  return (
    <ListItem
      leftAvatar={<Avatar src={profilePictureUri} />}
      rightIcon={<ActionInfo />}
      primaryText={
        <div>
          <Duration {...timeSlot.duration} />
          {` of ${subject.name} (${grade.name}) `}
          <DateTime value={timeSlot.startDate} />
        </div>
      }
      secondaryText={secondaryText}
    />
  );
};

export default createFragmentContainer(StudentJobSessionHistory, {
  session: graphql`
    fragment StudentJobSessionHistory_session on JobSession {
      timeSlot {
        startDate
        duration {
          hours
          minutes
        }
      }
      id
      number
      job {
        sessionCount
        createdAt
        acceptedJobOffer {
          tutor {
            fullname
            profilePictureUri
          }
          jobRequest {
            subject {
              name
            }
            grade {
              name
            }
          }
        }
      }
    }
  `,
});



// WEBPACK FOOTER //
// ./src/modules/admin/student/components/StudentJobSessionHistory.js